module.exports = {
  __depends__: [
    require(209),
    require(154),
    require(236),
    require(173),
    require(165),
    require(244),
    require(20)
  ],
  __init__: [ 'paletteProvider' ],
  paletteProvider: [ 'type', require(69) ]
};
